export const API_BASE = "https://aidatalake.kr/api/";  //프리 로컬 테스트
// export const API_BASE = "http://localhost:8020/api/";  //프리 로컬 테스트

